// extracted by mini-css-extract-plugin
module.exports = {"ReasonContainer":"Reason_ReasonContainer__3JRjL","Reason":"Reason_Reason__1A6_B","Description":"Reason_Description__3CeAO"};